@optional @link fn getWhitePoint() -> f32 { return 4.0; }

fn luminance(rgb: vec3<f32>) -> f32 {
  return dot(rgb, vec3<f32>(0.2126, 0.7152, 0.0722));
};

@export fn tonemapReinhard(color: vec4<f32>) -> vec4<f32> {
  let wp = getWhitePoint();
  let rgb = color.rgb;

  let lIn = luminance(rgb);
  let numerator = lIn * (1.0 + (lIn / (wp * wp)));
  let lOut = numerator / (1.0 + lIn);

  return vec4<f32>(rgb * lOut / lIn, color.a);
};

